import Modal from 'flarum/common/components/Modal';
export default class MatchDetailedVotesModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.match = this.attrs.match;
    this.votes = this.match.votes() || [];
    this.players = this.match.players() || [];

    // Data structure: users map of ratings
    this.voterMap = {};

    // Collect all users from votes
    this.votes.forEach(vote => {
      const user = vote.user();
      if (user && !this.voterMap[user.id()]) {
        this.voterMap[user.id()] = {
          username: user.displayName() || user.username() || app.translator.trans('nagusi-match-ratings.forum.modal.unknown_user'),
          avatarUrl: user.avatarUrl(),
          votes: {}
        };
      }
      const player = vote.player();
      if (user && player) {
        this.voterMap[user.id()].votes[player.id()] = vote.rating();
      }
    });

    // Calculate Stats
    const playerRatings = {};
    this.players.forEach(p => playerRatings[p.id()] = []);
    this.votes.forEach(vote => {
      const player = vote.player();
      if (player && playerRatings[player.id()]) {
        playerRatings[player.id()].push(vote.rating());
      }
    });
    this.stats = {
      mean: {},
      median: {}
    };
    this.players.forEach(p => {
      const pId = p.id();
      const ratings = playerRatings[pId] || [];
      if (ratings.length > 0) {
        // Mean
        const sum = ratings.reduce((a, b) => a + b, 0);
        this.stats.mean[pId] = (sum / ratings.length).toFixed(1);

        // Median
        const sorted = [...ratings].sort((a, b) => a - b);
        const mid = Math.floor(sorted.length / 2);
        this.stats.median[pId] = sorted.length % 2 !== 0 ? sorted[mid] : ((sorted[mid - 1] + sorted[mid]) / 2).toFixed(1);
      } else {
        this.stats.mean[pId] = '-';
        this.stats.median[pId] = '-';
      }
    });

    // Sort players by mean descending
    this.players.sort((a, b) => {
      const valA = parseFloat(this.stats.mean[a.id()]) || 0;
      const valB = parseFloat(this.stats.mean[b.id()]) || 0;
      return valB - valA;
    });

    // State for the accordion
    this.expandedPlayerId = null;
  }
  className() {
    return 'MatchDetailedVotesModal';
  }
  title() {
    return this.match.getName();
  }
  togglePlayer(id) {
    if (this.expandedPlayerId === id) {
      this.expandedPlayerId = null;
    } else {
      this.expandedPlayerId = id;
    }
  }
  content() {
    const voterIds = Object.keys(this.voterMap).filter(uid => Object.keys(this.voterMap[uid].votes).length > 0);
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Player-Votes-List"
    }, this.players.map(p => {
      const isExpanded = this.expandedPlayerId === p.id();
      const pId = p.id();
      const type = p.entityType() || 'player';
      let roleBadge = null;
      if (type === 'coach') {
        roleBadge = m("span", {
          className: "Player-Role-Badge coach"
        }, "Entrenador");
      } else if (type === 'team') {
        roleBadge = m("span", {
          className: "Player-Role-Badge team"
        }, "Equipo");
      } else {
        const pos = p.attribute('pivotPosition');
        if (pos !== null && pos !== undefined) {
          if (pos < 11) {
            roleBadge = m("span", {
              className: "Player-Role-Badge starter"
            }, "Titular");
          } else {
            roleBadge = m("span", {
              className: "Player-Role-Badge sub"
            }, "Suplente");
          }
        }
      }
      return m("div", {
        className: "Player-Vote-Card ".concat(isExpanded ? 'is-expanded' : ''),
        key: pId
      }, m("div", {
        className: "Player-Vote-Header",
        onclick: () => this.togglePlayer(pId)
      }, m("div", {
        className: "Player-Vote-Info"
      }, p.photoUrl() ? m("img", {
        src: p.photoUrl(),
        className: "Player-Avatar"
      }) : m("div", {
        className: "Player-Avatar-Placeholder"
      }, p.name().substring(0, 1)), m("span", {
        className: "player-name-wrapper"
      }, m("span", {
        className: "Player-Name"
      }, p.name()), roleBadge)), m("div", {
        className: "Player-Vote-Stats"
      }, m("div", {
        className: "Stat-Badge Mean"
      }, m("span", {
        className: "Stat-Label"
      }, "\u03A3"), m("span", {
        className: "Stat-Value"
      }, this.stats.mean[pId])), m("div", {
        className: "Stat-Badge Median"
      }, m("span", {
        className: "Stat-Label"
      }, "M"), m("span", {
        className: "Stat-Value"
      }, this.stats.median[pId])), m("i", {
        className: "fas fa-chevron-".concat(isExpanded ? 'up' : 'down', " Expand-Icon")
      }))), isExpanded && m("div", {
        className: "Player-Vote-Details"
      }, voterIds.length > 0 ? m("div", {
        className: "Voter-Grid"
      }, voterIds.map(uid => {
        const vote = this.voterMap[uid].votes[pId];
        // Only show voters who actually voted for this player
        if (vote === undefined || vote === null || vote === '') return null;
        return m("div", {
          className: "Voter-Vote-Item",
          key: uid
        }, m("div", {
          className: "Voter-Info-Mini"
        }, this.voterMap[uid].avatarUrl ? m("img", {
          src: this.voterMap[uid].avatarUrl,
          className: "Voter-Avatar-Mini"
        }) : m("div", {
          className: "Voter-Avatar-Placeholder-Mini"
        }, this.voterMap[uid].username.substring(0, 1)), m("span", {
          className: "Voter-Name"
        }, this.voterMap[uid].username)), m("div", {
          className: "Voter-Score"
        }, vote));
      })) : m("div", {
        className: "No-Votes-Message"
      }, app.translator.trans('nagusi-match-ratings.forum.modal.no_votes'))));
    })), voterIds.length === 0 && m("div", {
      style: "padding: 20px; text-align: center;"
    }, m("p", null, app.translator.trans('nagusi-match-ratings.forum.modal.no_votes'))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/MatchDetailedVotesModal', MatchDetailedVotesModal);